// Automatically generated file. Do not edit. Do not commit.
// (generated by gulpfile during build)
export const drivers = {};
import { Alfatron } from '../Alfatron';
drivers.Alfatron = Alfatron;
import { Alfatron21e } from '../Alfatron21e';
drivers.Alfatron21e = Alfatron21e;
import { AlfatronAmp } from '../AlfatronAmp';
drivers.AlfatronAmp = AlfatronAmp;
import { AlfatronDspTcp } from '../AlfatronDspTcp';
drivers.AlfatronDspTcp = AlfatronDspTcp;
import { AlfatronDspUdp } from '../AlfatronDspUdp';
drivers.AlfatronDspUdp = AlfatronDspUdp;
import { AlfatronMuheGen2 } from '../AlfatronMuheGen2';
drivers.AlfatronMuheGen2 = AlfatronMuheGen2;
import { AlfatronMukn } from '../AlfatronMukn';
drivers.AlfatronMukn = AlfatronMukn;
import { AlfatronSck41 } from '../AlfatronSck41';
drivers.AlfatronSck41 = AlfatronSck41;
import { AlfatronSck51 } from '../AlfatronSck51';
drivers.AlfatronSck51 = AlfatronSck51;
import { AlfatronScu61e } from '../AlfatronScu61e';
drivers.AlfatronScu61e = AlfatronScu61e;
import { AlfatronSmw42 } from '../AlfatronSmw42';
drivers.AlfatronSmw42 = AlfatronSmw42;
import { AlfatronWu4k } from '../AlfatronWu4k';
drivers.AlfatronWu4k = AlfatronWu4k;
import { AminoIr } from '../AminoIr';
drivers.AminoIr = AminoIr;
import { Aneuvideo } from '../Aneuvideo';
drivers.Aneuvideo = Aneuvideo;
import { AppleTvIr } from '../AppleTvIr';
drivers.AppleTvIr = AppleTvIr;
import { Arris } from '../Arris';
drivers.Arris = Arris;
import { AshlyMxaDsp } from '../AshlyMxaDsp';
drivers.AshlyMxaDsp = AshlyMxaDsp;
import { AshlyNeDsp } from '../AshlyNeDsp';
drivers.AshlyNeDsp = AshlyNeDsp;
import { Atdm0604 } from '../Atdm0604';
drivers.Atdm0604 = Atdm0604;
import { AtenUsb } from '../AtenUsb';
drivers.AtenUsb = AtenUsb;
import { AtenVideoSwitcher } from '../AtenVideoSwitcher';
drivers.AtenVideoSwitcher = AtenVideoSwitcher;
import { Atlona } from '../Atlona';
drivers.Atlona = Atlona;
import { AtlonaAmp } from '../AtlonaAmp';
drivers.AtlonaAmp = AtlonaAmp;
import { AtlonaMs52w } from '../AtlonaMs52w';
drivers.AtlonaMs52w = AtlonaMs52w;
import { AutomateVx } from '../AutomateVx';
drivers.AutomateVx = AutomateVx;
import { AvProMxNet } from '../AvProMxNet';
drivers.AvProMxNet = AvProMxNet;
import { AvProSwitcher } from '../AvProSwitcher';
drivers.AvProSwitcher = AvProSwitcher;
import { AveoUniversalApiV1 } from '../AveoUniversalApiV1';
drivers.AveoUniversalApiV1 = AveoUniversalApiV1;
import { Avocor } from '../Avocor';
drivers.Avocor = Avocor;
import { BarcoClickShare } from '../BarcoClickShare';
drivers.BarcoClickShare = BarcoClickShare;
import { BenQInteractiveFlatPanel } from '../BenQInteractiveFlatPanel';
drivers.BenQInteractiveFlatPanel = BenQInteractiveFlatPanel;
import { BenQProjector } from '../BenQProjector';
drivers.BenQProjector = BenQProjector;
import { BinaryMoip } from '../BinaryMoip';
drivers.BinaryMoip = BinaryMoip;
import { Blackbox } from '../Blackbox';
drivers.Blackbox = Blackbox;
import { Blackmagic } from '../Blackmagic';
drivers.Blackmagic = Blackmagic;
import { Blustream } from '../Blustream';
drivers.Blustream = Blustream;
import { BlustreamAcm200 } from '../BlustreamAcm200';
drivers.BlustreamAcm200 = BlustreamAcm200;
import { BoseSoundBar700 } from '../BoseSoundBar700';
drivers.BoseSoundBar700 = BoseSoundBar700;
import { BoseVideoBar } from '../BoseVideoBar';
drivers.BoseVideoBar = BoseVideoBar;
import { ChristieGsSeries } from '../ChristieGsSeries';
drivers.ChristieGsSeries = ChristieGsSeries;
import { ChristieSecure } from '../ChristieSecure';
drivers.ChristieSecure = ChristieSecure;
import { Cisco4742Ir } from '../Cisco4742Ir';
drivers.Cisco4742Ir = Cisco4742Ir;
import { CiscoDta170 } from '../CiscoDta170';
drivers.CiscoDta170 = CiscoDta170;
import { CiscoTelepresence } from '../CiscoTelepresence';
drivers.CiscoTelepresence = CiscoTelepresence;
import { ContemporaryResearch } from '../ContemporaryResearch';
drivers.ContemporaryResearch = ContemporaryResearch;
import { ControlByWebX400 } from '../ControlByWebX400';
drivers.ControlByWebX400 = ControlByWebX400;
import { ConvergePro2 } from '../ConvergePro2';
drivers.ConvergePro2 = ConvergePro2;
import { Datapath } from '../Datapath';
drivers.Datapath = Datapath;
import { Denon500BD } from '../Denon500BD';
drivers.Denon500BD = Denon500BD;
import { Denon900R } from '../Denon900R';
drivers.Denon900R = Denon900R;
import { DenonAvr } from '../DenonAvr';
drivers.DenonAvr = DenonAvr;
import { DigitalProjection } from '../DigitalProjection';
drivers.DigitalProjection = DigitalProjection;
import { Directv } from '../Directv';
drivers.Directv = Directv;
import { DirectvNetwork } from '../DirectvNetwork';
drivers.DirectvNetwork = DirectvNetwork;
import { DishHopper3Ir } from '../DishHopper3Ir';
drivers.DishHopper3Ir = DishHopper3Ir;
import { Dm8000 } from '../Dm8000';
drivers.Dm8000 = Dm8000;
import { Dten } from '../Dten';
drivers.Dten = Dten;
import { EclerVida } from '../EclerVida';
drivers.EclerVida = EclerVida;
import { Epiphan } from '../Epiphan';
drivers.Epiphan = Epiphan;
import { EpsonVp21 } from '../EpsonVp21';
drivers.EpsonVp21 = EpsonVp21;
import { Extron } from '../Extron';
drivers.Extron = Extron;
import { ForTheRecord } from '../ForTheRecord';
drivers.ForTheRecord = ForTheRecord;
import { FsrDvHsw } from '../FsrDvHsw';
drivers.FsrDvHsw = FsrDvHsw;
import { FsrDvT6ss } from '../FsrDvT6ss';
drivers.FsrDvT6ss = FsrDvT6ss;
import { FsrV1 } from '../FsrV1';
drivers.FsrV1 = FsrV1;
import { GlobalCache } from '../GlobalCache';
drivers.GlobalCache = GlobalCache;
import { HallResearchEmcee } from '../HallResearchEmcee';
drivers.HallResearchEmcee = HallResearchEmcee;
import { HallResearchHsm } from '../HallResearchHsm';
drivers.HallResearchHsm = HallResearchHsm;
import { HallResearchSc } from '../HallResearchSc';
drivers.HallResearchSc = HallResearchSc;
import { HallResearchSw } from '../HallResearchSw';
drivers.HallResearchSw = HallResearchSw;
import { HisenseIr } from '../HisenseIr';
drivers.HisenseIr = HisenseIr;
import { HitachiProjector } from '../HitachiProjector';
drivers.HitachiProjector = HitachiProjector;
import { I3TouchEx } from '../I3TouchEx';
drivers.I3TouchEx = I3TouchEx;
import { I3TouchXOne } from '../I3TouchXOne';
drivers.I3TouchXOne = I3TouchXOne;
import { IView } from '../IView';
drivers.IView = IView;
import { InogeniCam230 } from '../InogeniCam230';
drivers.InogeniCam230 = InogeniCam230;
import { InogeniCam300 } from '../InogeniCam300';
drivers.InogeniCam300 = InogeniCam300;
import { InogeniShare2u } from '../InogeniShare2u';
drivers.InogeniShare2u = InogeniShare2u;
import { InogeniUsbToggle } from '../InogeniUsbToggle';
drivers.InogeniUsbToggle = InogeniUsbToggle;
import { JblSynthesis } from '../JblSynthesis';
drivers.JblSynthesis = JblSynthesis;
import { JustAddPower } from '../JustAddPower';
drivers.JustAddPower = JustAddPower;
import { JustAddPowerAmp } from '../JustAddPowerAmp';
drivers.JustAddPowerAmp = JustAddPowerAmp;
import { KanexPro } from '../KanexPro';
drivers.KanexPro = KanexPro;
import { Kramer } from '../Kramer';
drivers.Kramer = Kramer;
import { LG } from '../LG';
drivers.LG = LG;
import { Lencore } from '../Lencore';
drivers.Lencore = Lencore;
import { LgDigitalSignage } from '../LgDigitalSignage';
drivers.LgDigitalSignage = LgDigitalSignage;
import { LgIr } from '../LgIr';
drivers.LgIr = LgIr;
import { LgLed } from '../LgLed';
drivers.LgLed = LgLed;
import { LgProjectorIr } from '../LgProjectorIr';
drivers.LgProjectorIr = LgProjectorIr;
import { LibertyAvDLE } from '../LibertyAvDLE';
drivers.LibertyAvDLE = LibertyAvDLE;
import { Lightware } from '../Lightware';
drivers.Lightware = Lightware;
import { LiteTouch } from '../LiteTouch';
drivers.LiteTouch = LiteTouch;
import { Lutron } from '../Lutron';
drivers.Lutron = Lutron;
import { MechoNetZgn } from '../MechoNetZgn';
drivers.MechoNetZgn = MechoNetZgn;
import { Monoprice } from '../Monoprice';
drivers.Monoprice = Monoprice;
import { NanolumensCaptivateTcp } from '../NanolumensCaptivateTcp';
drivers.NanolumensCaptivateTcp = NanolumensCaptivateTcp;
import { NanolumensCaptivateUdp } from '../NanolumensCaptivateUdp';
drivers.NanolumensCaptivateUdp = NanolumensCaptivateUdp;
import { NecMultisync } from '../NecMultisync';
drivers.NecMultisync = NecMultisync;
import { NecProjector } from '../NecProjector';
drivers.NecProjector = NecProjector;
import { Netvio } from '../Netvio';
drivers.Netvio = Netvio;
import { NovastarHSeriesTcp } from '../NovastarHSeriesTcp';
drivers.NovastarHSeriesTcp = NovastarHSeriesTcp;
import { NovastarHSeriesUdp } from '../NovastarHSeriesUdp';
drivers.NovastarHSeriesUdp = NovastarHSeriesUdp;
import { NovastarVxSeries } from '../NovastarVxSeries';
drivers.NovastarVxSeries = NovastarVxSeries;
import { NovoTouch } from '../NovoTouch';
drivers.NovoTouch = NovoTouch;
import { Nureva } from '../Nureva';
drivers.Nureva = Nureva;
import { OnkyoRz } from '../OnkyoRz';
drivers.OnkyoRz = OnkyoRz;
import { OptomaWuProjector } from '../OptomaWuProjector';
drivers.OptomaWuProjector = OptomaWuProjector;
import { OreiMatrix } from '../OreiMatrix';
drivers.OreiMatrix = OreiMatrix;
import { P300 } from '../P300';
drivers.P300 = P300;
import { PaceRng } from '../PaceRng';
drivers.PaceRng = PaceRng;
import { PanasonicCamera } from '../PanasonicCamera';
drivers.PanasonicCamera = PanasonicCamera;
import { PanasonicDisplayIr } from '../PanasonicDisplayIr';
drivers.PanasonicDisplayIr = PanasonicDisplayIr;
import { PanasonicDisplayRs232 } from '../PanasonicDisplayRs232';
drivers.PanasonicDisplayRs232 = PanasonicDisplayRs232;
import { PanasonicDisplayTelnet } from '../PanasonicDisplayTelnet';
drivers.PanasonicDisplayTelnet = PanasonicDisplayTelnet;
import { PanasonicProjectorRs232 } from '../PanasonicProjectorRs232';
drivers.PanasonicProjectorRs232 = PanasonicProjectorRs232;
import { PanasonicProjectorTelnet } from '../PanasonicProjectorTelnet';
drivers.PanasonicProjectorTelnet = PanasonicProjectorTelnet;
import { PensarLed } from '../PensarLed';
drivers.PensarLed = PensarLed;
import { Philips } from '../Philips';
drivers.Philips = Philips;
import { Pjlink } from '../Pjlink';
drivers.Pjlink = Pjlink;
import { PlanarHbSeries } from '../PlanarHbSeries';
drivers.PlanarHbSeries = PlanarHbSeries;
import { PlanarMSeries } from '../PlanarMSeries';
drivers.PlanarMSeries = PlanarMSeries;
import { PlanarVideoController } from '../PlanarVideoController';
drivers.PlanarVideoController = PlanarVideoController;
import { PureLink } from '../PureLink';
drivers.PureLink = PureLink;
import { QSys } from '../QSys';
drivers.QSys = QSys;
import { Radius } from '../Radius';
drivers.Radius = Radius;
import { Roku } from '../Roku';
drivers.Roku = Roku;
import { SamsungIr } from '../SamsungIr';
drivers.SamsungIr = SamsungIr;
import { SamsungPro } from '../SamsungPro';
drivers.SamsungPro = SamsungPro;
import { SamsungProTv } from '../SamsungProTv';
drivers.SamsungProTv = SamsungProTv;
import { SamsungSmt } from '../SamsungSmt';
drivers.SamsungSmt = SamsungSmt;
import { SceptreIr } from '../SceptreIr';
drivers.SceptreIr = SceptreIr;
import { SciAtlExplorer } from '../SciAtlExplorer';
drivers.SciAtlExplorer = SciAtlExplorer;
import { SharpAquos } from '../SharpAquos';
drivers.SharpAquos = SharpAquos;
import { SharpIr } from '../SharpIr';
drivers.SharpIr = SharpIr;
import { SharpPnuh } from '../SharpPnuh';
drivers.SharpPnuh = SharpPnuh;
import { SmartBoard } from '../SmartBoard';
drivers.SmartBoard = SmartBoard;
import { SonosArc } from '../SonosArc';
drivers.SonosArc = SonosArc;
import { SonyBluRayIr } from '../SonyBluRayIr';
drivers.SonyBluRayIr = SonyBluRayIr;
import { SonyBravia } from '../SonyBravia';
drivers.SonyBravia = SonyBravia;
import { SonyBraviaIr } from '../SonyBraviaIr';
drivers.SonyBraviaIr = SonyBraviaIr;
import { SonyBraviaRs232 } from '../SonyBraviaRs232';
drivers.SonyBraviaRs232 = SonyBraviaRs232;
import { SonyRdrKv555 } from '../SonyRdrKv555';
drivers.SonyRdrKv555 = SonyRdrKv555;
import { SonyVplProjector } from '../SonyVplProjector';
drivers.SonyVplProjector = SonyVplProjector;
import { SoundStructure } from '../SoundStructure';
drivers.SoundStructure = SoundStructure;
import { SpectrumIr } from '../SpectrumIr';
drivers.SpectrumIr = SpectrumIr;
import { StewartAudio } from '../StewartAudio';
drivers.StewartAudio = StewartAudio;
import { StewartAudioFlxE } from '../StewartAudioFlxE';
drivers.StewartAudioFlxE = StewartAudioFlxE;
import { Sunbrite } from '../Sunbrite';
drivers.Sunbrite = Sunbrite;
import { TclIr } from '../TclIr';
drivers.TclIr = TclIr;
import { Tesira } from '../Tesira';
drivers.Tesira = Tesira;
import { Tivo } from '../Tivo';
drivers.Tivo = Tivo;
import { TivoIr } from '../TivoIr';
drivers.TivoIr = TivoIr;
import { ToaAmCf1 } from '../ToaAmCf1';
drivers.ToaAmCf1 = ToaAmCf1;
import { ToshibaIr } from '../ToshibaIr';
drivers.ToshibaIr = ToshibaIr;
import { USwitch } from '../USwitch';
drivers.USwitch = USwitch;
import { UniversalIr } from '../UniversalIr';
drivers.UniversalIr = UniversalIr;
import { UserDriverSocket } from '../UserDriverSocket';
drivers.UserDriverSocket = UserDriverSocket;
import { VaddioCamera } from '../VaddioCamera';
drivers.VaddioCamera = VaddioCamera;
import { ViewSonicViewBoard } from '../ViewSonicViewBoard';
drivers.ViewSonicViewBoard = ViewSonicViewBoard;
import { VirtualDisplay } from '../VirtualDisplay';
drivers.VirtualDisplay = VirtualDisplay;
import { ViscaTcp } from '../ViscaTcp';
drivers.ViscaTcp = ViscaTcp;
import { ViscaUdp } from '../ViscaUdp';
drivers.ViscaUdp = ViscaUdp;
import { VisionarySolutions } from '../VisionarySolutions';
drivers.VisionarySolutions = VisionarySolutions;
import { VisionarySolutions5 } from '../VisionarySolutions5';
drivers.VisionarySolutions5 = VisionarySolutions5;
import { VitecAvediaStreamIr } from '../VitecAvediaStreamIr';
drivers.VitecAvediaStreamIr = VitecAvediaStreamIr;
import { VivitekProjector3and4Series } from '../VivitekProjector3and4Series';
drivers.VivitekProjector3and4Series = VivitekProjector3and4Series;
import { VivitekProjector7000 } from '../VivitekProjector7000';
drivers.VivitekProjector7000 = VivitekProjector7000;
import { VizioIr } from '../VizioIr';
drivers.VizioIr = VizioIr;
import { WolfVisionCynap } from '../WolfVisionCynap';
drivers.WolfVisionCynap = WolfVisionCynap;
import { WyreStormSw130Tx } from '../WyreStormSw130Tx';
drivers.WyreStormSw130Tx = WyreStormSw130Tx;
import { WyreStormSw740Tx } from '../WyreStormSw740Tx';
drivers.WyreStormSw740Tx = WyreStormSw740Tx;
import { Xantech } from '../Xantech';
drivers.Xantech = Xantech;
import { XilicaSolaro } from '../XilicaSolaro';
drivers.XilicaSolaro = XilicaSolaro;
import { Yamaha } from '../Yamaha';
drivers.Yamaha = Yamaha;
import { YamahaAdecia } from '../YamahaAdecia';
drivers.YamahaAdecia = YamahaAdecia;
import { YamahaMtx } from '../YamahaMtx';
drivers.YamahaMtx = YamahaMtx;
import { Yinker } from '../Yinker';
drivers.Yinker = Yinker;
import { ZeeVee } from '../ZeeVee';
drivers.ZeeVee = ZeeVee;
import { Zoom } from '../Zoom';
drivers.Zoom = Zoom;
